<template>
    <div class="row recent-orders">
        <div class="col-md-12">
            <div class="row">
                <div class="col-sm-12 col-md-6">
                    <h3>
                        {{
                            headerTitle
                                ? headerTitle
                                : pageType != "dashboard"
                                ? "Orders"
                                : "Recent Orders"
                        }}
                    </h3>
                    <div class="form-check" v-if="this.user.role.id == 1">
                        <input
                            class="form-check-input"
                            @click="toggleAutoConfirm"
                            type="checkbox"
                            value=""
                            :checked="autoConfirm"
                        />
                        <label class="form-check-label" for="flexCheckChecked">
                            Auto Confirm Orders?
                        </label>
                    </div>
                </div>
                <div
                    v-if="pageType != 'dashboard'"
                    class="col-sm-12 col-md-3 pb-2"
                >
                    <div class="row align-items-center">
                        <div class="col-md-3">
                            <label
                                class="form-control-label text-muted"
                                for="filter_status"
                                >Filter Status:
                            </label>
                        </div>
                        <div class="col-md-9">
                            <select
                                id="filter_status"
                                class="form-control"
                                v-model="searchStatus"
                                @change="selectStatus"
                            >
                                <option value="all">ALL</option>
                                <option value="Open">Open</option>
                                <option value="Validated">Validated</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div
                    v-if="pageType != 'dashboard'"
                    class="col-sm-12 col-md-3 text-right"
                >
                    <div class="form-group">
                        <div class="input-group search-field">
                            <input
                                class="form-control"
                                type="text"
                                placeholder="Search Orders"
                                v-model="searchTerm"
                                autocomplete="off"
                            />
                            <div class="input-group-prepend">
                                <span class="input-group-text"
                                    ><i class="fas fa-search"></i
                                ></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <table
                class="table table-responsive table-striped border-bottom mt-2"
            >
                <thead class="thead-light">
                    <tr>
                        <th style="width: 9em">Order Number</th>
                        <th style="width: 9em">Order Date</th>
                        <th>Pricelist</th>
                        <th style="width: 9em">PO Number</th>
                        <th>SKU</th>
                        <th>Name</th>
                        <th style="width: 11em">Dealer</th>
                        <th style="width: 11em">Sales Rep</th>
                        <th class="text-right" style="width: 8em">Total</th>
                        <th class="text-center" style="width: 8em">Status</th>
                        <th style="width: 9em"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="order in paginatedOrders" :key="order.id">
                        <td class="hyperlink" @click="viewOrder(order)">
                            <b v-if="user.is_demo">ORD-12345</b>
                            <b v-else>{{ order.id == 0 ? "" : order.id }}</b>
                        </td>
                        <td>{{ order.order_date }}</td>
                        <td>
                            <template v-if="order.pricelist != null">
                                {{ order.pricelist.pricelist_name }}
                            </template>
                        </td>
                        <td>
                            <b v-if="user.is_demo">PO-12345</b>
                            <b v-else>{{ order.po_number }}</b>
                        </td>
                        <td><b>{{ order.line_items.length > 0 ? order.line_items[0].sku : '' }}</b></td>
                        <td><b>{{ order.line_items.length > 0 ? order.line_items[0].name : '' }}</b></td>
                        <td>{{ order.location.name }}</td>
                        <td>{{ order.location.sales_rep?.name }}</td>
                        <td class="text-right">
                            ${{ $filters.moneyFormat(order.total) }}
                        </td>
                        <td>
                            <div
                                class="order-status"
                                :class="order.order_status.toLowerCase()"
                            >
                                {{ order.order_status }}
                            </div>

                            <div
                                v-if="order.is_paid == 1"
                                class="order-status paid mt-1"
                            >
                                PAID
                            </div>
                        </td>
                        <td class="text-right">
                            <span
                                class="px-1 view-action"
                                @click="viewOrder(order)"
                                ><i class="fa fa-eye" aria-hidden="true"></i>
                                VIEW<br
                            /></span>
                            <span
                                v-if="
                                    !order.is_sync &&
                                    order.order_status.toLowerCase() ==
                                        'pending approval'
                                "
                                class="px-1 view-action"
                                @click="editOrder(order)"
                                ><i class="fa fa-pencil" aria-hidden="true"></i>
                                EDIT<br
                            /></span>
                            <span
                                v-if="order.order_status == 'Pending Approval'"
                                class="px-1 view-action"
                                @click="confirmModal(order)"
                                ><i class="fa fa-trash" aria-hidden="true"></i>
                                DELETE</span
                            >
                        </td>
                        <!-- <td class="text-center">
                            <button
                                v-if="order.is_speq"
                                class="speq-order-status"
                                :class="order.speq_order_status == 1 ? 'open' : 'sold'"
                            >
                                {{ order.speq_order_status == 1 ? 'Open' : 'Sold' }}
                            </button>
                            <button
                                v-else
                                class="order-status"
                                :class="order.order_status.toLowerCase()"
                            >
                                {{ order.order_status }}
                            </button>
                        </td>
                        <td class="text-left">
                            <div v-if="(order.speq_order_status == 1 || order.speq_order_status == 2)
                                && order.speq_order_documents.length == 0" class="d-flex align-items-start">
                                <button v-if="order.speq_order_documents.length == 0" 
                                    @click="openModalUploadDocs(order)" 
                                    class="speq-order-status mr-2" 
                                    :class="user.role.id == 1 ? 'disabled' : 'upload'"
                                    :disabled="user.role.id == 1">MARK AS SOLD</button>
                                <span v-if="order.speq_order_documents.length == 0" class="font-weight-bold">
                                    (<a href="/speq/valid-documents" target="_blank">What's needed</a>)
                                </span>
                                <span
                                    v-if="order.speq_order_documents.length == 0"
                                    style="min-width: 75px"
                                    class="px-1 ml-3 view-action"
                                    @click="viewOrder(order)"
                                    ><i class="fa fa-eye" aria-hidden="true"></i>
                                    VIEW<br
                                /></span>
                            </div>
                            <div v-if="(order.speq_order_status == 1 || order.speq_order_status == 2)
                                && order.speq_order_documents.length > 0" class="">
                                <template v-for="docu in order.speq_order_documents" :key="docu.id">
                                    <div class="font-weight-bold">
                                        <a :href="docu.attachments" target="_blank">{{ docu.display_name }}</a>
                                    </div>
                                </template>
                            </div>
                        </td> -->
                    </tr>
                </tbody>
            </table>

            <!-- Pagination -->
            <table-pagination
                v-show="pageType != 'dashboard'"
                v-model="paginatedOrders"
                :all-rows="searchAllOrdersbyTerm"
                :perPage="perPage"
                @updateRow="updateRow"
            >
            </table-pagination>
        </div>

        <!-- Validated ORDERS -->
        <!-- <div
            v-if="user.role.id == 1 || user.role.id == 4 || user.role.id == 5"
            class="col-md-12"
        > -->
        <div
            v-if="false"
        >
            <div class="row">
                <div class="col-sm-12 col-md-6">
                    <h3>Validated Orders</h3>
                </div>
            </div>
            <table
                class="table table-responsive table-striped border-bottom mt-2"
            >
                <thead class="thead-light">
                    <tr>
                        <th style="width: 9em">Order Number</th>
                        <th style="width: 9em">Order Date</th>
                        <th>Pricelist</th>
                        <th style="width: 9em">PO Number</th>
                        <th>SKU</th>
                        <th>Name</th>
                        <th style="width: 11em">Dealer</th>
                        <th style="width: 11em">Sales Rep</th>
                        <th class="text-right" style="width: 8em">Total</th>
                        <th class="text-center" style="width: 8em">Status</th>
                        <th style="width: 23em"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="order in paginatedValidatedOrders" :key="order.id">
                        <td class="hyperlink" @click="viewOrder(order)">
                            <b v-if="user.is_demo">ORD-12345</b>
                            <b v-else>{{ order.id == 0 ? "" : order.id }}</b>
                        </td>
                        <td>{{ order.order_date }}</td>
                        <td>
                            <template v-if="order.pricelist != null">
                                {{ order.pricelist.pricelist_name }}
                            </template>
                        </td>
                        <td>
                            <b v-if="user.is_demo">PO-12345</b>
                            <b v-else>{{ order.po_number }}</b>
                        </td>
                        <td><b>{{ order.line_items ? order.line_items[0].sku : '' }}</b></td>
                        <td><b>{{ order.line_items ? order.line_items[0].name : '' }}</b></td>
                        <td>{{ order.location.name }}</td>
                        <td>{{ order.location.sales_rep?.name }}</td>
                        <td class="text-right">
                            ${{ $filters.moneyFormat(order.total) }}
                        </td>
                        <td class="text-center">
                            <button
                                v-if="order.is_speq"
                                class="speq-order-status"
                                :class="order.speq_order_status == 1 ? 'open' : 'sold'"
                            >
                                {{ order.speq_order_status == 1 ? 'Open' : 'Sold' }}
                            </button>
                            <button
                                v-else
                                class="order-status"
                                :class="order.order_status.toLowerCase()"
                            >
                                {{ order.order_status }}
                            </button>

                            <!-- <div
                                v-if="order.is_paid == 1"
                                class="order-status paid mt-1"
                            >
                                PAID
                            </div> -->
                        </td>
                        <td class="text-left">
                            <div v-if="(order.speq_order_status == 1 || order.speq_order_status == 2)
                                && order.speq_order_documents.length == 0" class="d-flex align-items-start">
                                <span
                                    v-if="order.speq_order_documents.length == 0"
                                    style="min-width: 75px"
                                    class="px-1 view-action"
                                    @click="viewOrder(order)"
                                    ><i class="fa fa-eye" aria-hidden="true"></i>
                                    VIEW<br
                                /></span>
                                <button v-if="order.speq_order_documents.length == 0" @click="openModalUploadDocs(order)" class="speq-order-status upload mr-2">UPLOAD</button>
                                <span v-if="order.speq_order_documents.length == 0" class="font-weight-bold">
                                    Customer's SPEQ documents (<a href="/speq/valid-documents" target="_blank">what is this?</a>)
                                </span>
                            </div>
                            <div v-if="(order.speq_order_status == 1 || order.speq_order_status == 2)
                                && order.speq_order_documents.length > 0" class="">
                                <template v-for="docu in order.speq_order_documents" :key="docu.id">
                                    <div class="font-weight-bold">
                                        <a :href="docu.attachments" target="_blank">{{ docu.display_name }}</a>
                                    </div>
                                </template>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>

            <!-- Pagination -->
            <table-pagination
                v-model="paginatedValidatedOrders"
                :all-rows="searchAllOrdersbyTermValidated"
                :perPage="perPage2"
                @updateRow="updateRow2"
            >
            </table-pagination>
        </div>

        <!-- Confirmation modal -->
        <b-modal v-model="modalShowConfirm" hide-footer>
            <Confirmation
                v-if="modalShowConfirm"
                :title="'Are you sure you want to delete this order?'"
                @custom-func="deleteOrderById"
                @close-modal="closeModalConfirm"
            />
        </b-modal>

        <!-- Add sub user modal -->
        <!-- <b-modal
            style="z-index: 99999;"
            v-model="modalShowUploadDocs"
            :title="'Upload Documents'"
            hide-footer
        > -->

        <!-- Upload Document modal -->
        <b-modal
            class="speq-upload"
            v-model="modalShowUploadDocs"
            hide-footer
        >
            <SpeqUploadDocumentsModal
                v-if="modalShowUploadDocs"
                :modal-data="modalData"
                :location-data="locationData"
                @close-modal="closeModalUploadDocs"
                @update-orders="getSpeqOrders"
            />
        </b-modal>
    </div>
</template>

<script>
import { computed, onMounted } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import TablePagination from "@/components/TablePagination.vue";

import Confirmation from "@/components/Confirmation.vue";
import SpeqUploadDocumentsModal from '@/components/speq/modals/SpeqUploadDocumentsModal.vue';

export default {
    props: ["pageType", "pageType2", "setStatus", "headerTitle"],
    emits: [],
    components: {
        TablePagination,
        Confirmation,
        SpeqUploadDocumentsModal
    },
    setup() {
        const store = useStore();
        const route = useRoute();

        let user = computed(function () {
            return store.state.user;
        });
        let allOrders = computed(function () {
            return store.getters.allOrders;
        });
        let currentLocation = computed(function () {
            return store.state.currentLocation;
        });
        let validatedOrders = computed(function () {
            return store.state.validatedOrders;
        });

        let settings = computed(function () {
            return store.state.settings;
        });

        function getAllOrders(currentLocation) {
            store.dispatch("getAllOrders", { 
                location_id: currentLocation.id,
                is_speq: 1, //SPEQ ORDERS
                // order_type_id: 38
                order_type_id: 50
            });
        }

        function getNewSpeqOrders(currentLocation) {
            store.dispatch("getAllOrders", { 
                location_id: currentLocation.id,
                is_speq: 1, //SPEQ ORDERS
                // order_type_id: 38
                order_type_id: 50
            });
        }

        function setOrderInfo(order) {
            store.commit("setOrderInfo", order);
        }

        function searchOrders(val) {
            store.dispatch("searchOrders", val);
        }

        function getAllValidatedOrders() {
            store.dispatch("getAllValidatedOrders");
        }

        onMounted(() => {});

        return {
            store,
            route,
            user,
            allOrders,
            currentLocation,
            validatedOrders,
            settings,
            getAllOrders,
            getNewSpeqOrders,
            setOrderInfo,
            searchOrders,
            getAllValidatedOrders,
        };
    },
    data() {
        return {
            paginatedOrders: [],
            perPage: this.pageType == "dashboard" && this.pageType2 ? 5 : 50,
            searchTerm: "",
            searchStatus: "all",
            modalShowConfirm: false,
            reqOrder: {
                id: null,
                location_id: null,
            },
            paginatedValidatedOrders: [],
            perPage2: 50,
            modalShowUploadDocs: false,
            modalData: {},
            locationData: {}
        };
    },
    computed: {
        searchAllOrdersbyTerm() {
            if (this.searchTerm === "" && this.searchStatus === "all") {
                return this.allOrders;
            }

            var filterArr = [];
            var filterArr2 = [];
            var result = [];

            
            if (this.searchStatus !== "all") {
                this.allOrders.forEach((order) => {
                    if (this.searchStatus == "Open") {
                        if ((order.speq_order_status == 1 || order.speq_order_status == 2) && 
                            order.speq_order_documents.length == 0
                        ) {
                            filterArr.push(order);
                        }
                    }
                    if (this.searchStatus == "Validated") {
                        if ((order.speq_order_status == 1 || order.speq_order_status == 2) && order.speq_order_documents.length > 0) {
                            filterArr.push(order);
                        }
                    }
                });
            }

            if (this.searchTerm !== "") {
                this.allOrders.forEach((order) => {
                    let pricelist_name = order.pricelist
                        ? order.pricelist.pricelist_name
                        : "";
                    let searchTermLower = this.searchTerm.toLowerCase();

                    if (
                        (order.po_number &&
                            order.po_number
                                .toLowerCase()
                                .includes(searchTermLower)) ||
                        (order.order_number &&
                            order.order_number
                                .toLowerCase()
                                .includes(searchTermLower)) ||
                        (order.payment_terms &&
                            order.payment_terms
                                .toLowerCase()
                                .includes(searchTermLower)) ||
                        (order.notes &&
                            order.notes
                                .toLowerCase()
                                .includes(searchTermLower)) ||
                        (order.location &&
                            order.location.name &&
                            order.location.name
                                .toLowerCase()
                                .includes(searchTermLower)) ||
                        (String(order.id) &&
                            String(order.id)
                                .toLowerCase()
                                .includes(searchTermLower)) ||
                        (pricelist_name &&
                            pricelist_name
                                .toLowerCase()
                                .includes(searchTermLower)) ||
                        (order.location &&
                            order.location.sales_rep &&
                            order.location.sales_rep.name &&
                            order.location.sales_rep.name
                                .toLowerCase()
                                .includes(searchTermLower))
                    ) {
                        filterArr2.push(order);
                    }
                });
            }

            if (this.searchStatus !== "all" && this.searchTerm !== "") {
                result = filterArr.filter(
                    (c) => filterArr2.findIndex((x) => x.id == c.id) > -1
                );
            } else if (this.searchStatus !== "all" && this.searchTerm === "") {
                result = filterArr;
            } else if (this.searchStatus === "all" && this.searchTerm !== "") {
                result = filterArr2;
            }

            return result;
        },

        searchAllOrdersbyTermValidated() {
            var filterArr = [];

            this.allOrders.forEach((order) => {
                if (order.speq_order_status == 2 && order.speq_order_documents.length > 0) {
                    filterArr.push(order);
                }
            });

            return filterArr;
        },

        autoConfirm() {
            return this.$store.state.settings.auto_confirm_orders;
        },
    },
    watch: {
        paginatedOrders(newVal, oldVal) {
            // this.onPageChanged(newPage);
        },
    },
    mounted() {
        console.log('this.route.name',this.route.name)
        if (this.route.name == "newSpeqOrders") {
            this.getNewSpeqOrders(this.currentLocation);

        } else {
            if (this.route.query.filter && this.route.query.filter == "open") {
                this.searchStatus = "Open";
                this.getAllOrders(this.currentLocation);
            } else {
                this.searchStatus = "all";
                this.getAllOrders(this.currentLocation);
            }

            if (this.setStatus) {
                this.searchStatus = this.setStatus;
            }
        }
        

        // if (
        //     this.user.role.id == 1 ||
        //     this.user.role.id == 4 ||
        //     this.user.role.id == 5
        // ) {
        //     this.getAllValidatedOrders();
        // }

    },
    methods: {
        toggleAutoConfirm() {
            // console.log(123);
            axios.get("api/settings/toggle/auto-confirm").then((res) => {
                this.$store.dispatch("getSettings");
            });
        },
        updateRow(val) {
            this.paginatedOrders = val;
        },
        updateRow2(val) {
            this.paginatedValidatedOrders = val;
        },
        viewOrder(order) {
            // this.setOrderInfo(order);
            this.$router.push({
                name: "speqOrderInfo",
                params: { id: order.id, order_number: order.order_number },
            });
        },
        editOrder(order) {
            // this.setOrderInfo(order);
            this.$router.push({
                name: "speqOrderEdit",
                params: { id: order.id, order_number: order.order_number },
            });
        },
        confirmModal(order) {
            this.reqOrder = {
                id: order.id,
                location_id: this.currentLocation.id,
            };
            this.modalShowConfirm = !this.modalShowConfirm;
        },
        deleteOrderById() {
            this.store.dispatch("deleteOrder", this.reqOrder).then((resp) => {
                window.emitter.emit("alertSuccess", {
                    message: "Order deleted successfully!",
                });
            });
        },
        closeModalConfirm() {
            this.modalShowConfirm = !this.modalShowConfirm;
        },
        onChange() {
            this.searchOrders({
                searchTerm: this.searchTerm,
            });
        },
        openModalUploadDocs(data) {
            this.modalData = data;
            this.locationData = this.currentLocation;
            this.modalShowUploadDocs = !this.modalShowUploadDocs;
        },
        closeModalUploadDocs() {
            // this.getNewSpeqOrders(this.currentLocation)
            this.modalShowUploadDocs = !this.modalShowUploadDocs;
        },
        getSpeqOrders() {
            this.getNewSpeqOrders(this.currentLocation)
        }
    },
};
</script>
